import React from 'react';
import { productDetails } from '../../data/productContent';
import { productImages } from '../../data/siteConfig';
const detailGroups = [{
  title: 'Mask & Light',
  labels: ['Color', 'Model', 'Technology', 'Laser emitters', 'Blue LEDs', 'Wavelengths']
}, {
  title: 'Controls & Sessions',
  labels: ['Operating modes', 'Brightness', 'Timer', 'Controls', 'Guidance']
}, {
  title: 'Fit & Charging',
  labels: ['Shell', 'Eye area', 'Fit', 'Charging', 'Battery capacity']
}];
export function ProductDetails() {
  return <section id="details" aria-labelledby="details-title" className="scroll-mt-16" data-id="element-250" data-mp="3n81fe3myy474">
      <div className="mx-auto max-w-page px-5 py-20 md:px-10 lg:py-24" data-id="element-251" data-mp="39ir9948xucch">
        <div className="grid items-center gap-8 md:grid-cols-[1fr_360px] md:gap-12 lg:gap-20" data-id="element-252" data-mp="3djb6e7tihfym">
          <div className="max-w-lg" data-id="element-253" data-mp="53ri7n7p6nqf">
            <h2 id="details-title" className="font-display text-4xl font-medium leading-tight text-ink md:text-[52px]" data-id="element-254" data-mp="52ooz8mwk97c">
              The Details.
            </h2>
            <p className="mt-4 max-w-md text-[17px] leading-relaxed text-ink-muted" data-id="element-255" data-mp="1o2g5tqadn67h">
              The essentials of the mask and kit. Full instructions are in the included user manual.
            </p>
          </div>
          <figure className="w-full max-w-[405px] md:max-w-none" data-id="element-256" data-mp="1xt0xetrmvagw">
            {/* Photo-only viewport of the supplied detail graphic. All technical and comfort claims stay outside the crop. */}
            <svg viewBox="0 133 405 284" width="405" height="284" role="img" aria-labelledby="details-photo-title" className="block h-auto w-full overflow-hidden rounded-md border border-line bg-canvas-deep" data-id="element-257" data-mp="26so1xofnswe6">
              <title id="details-photo-title" data-id="element-258" data-mp="2bs0oe82mc1g8">Close-up of the mask's side controls and USB charging port</title>
              <image href={productImages.detail.src} width="800" height="1372" data-id="element-259" data-mp="mef2idnfujxl" />
            </svg>
            <figcaption className="mt-3 text-[14px] text-ink-muted" data-id="element-260" data-mp="hfau3p8c8q8b">Side controls and charging port.</figcaption>
          </figure>
        </div>
        <div data-details-groups className="mt-10 grid gap-9 lg:mt-12 lg:grid-cols-3 lg:gap-10" data-id="element-261" data-mp="2hiv9fh4da8kh">
          {detailGroups.map(group => <div key={group.title} data-details-group className="min-w-0 border-t border-ink pt-5" data-id="element-262" data-mp="2qgxgoeep1xg7">
              <h3 className="font-display text-[28px] font-medium leading-tight text-ink" data-id="element-263" data-mp="2vgjt4lmp79ny">{group.title}</h3>
              <dl className="mt-4" data-id="element-264" data-mp="30ebmlk2zr3u9">
                {productDetails.filter(row => group.labels.includes(row.label)).map(row => <div key={row.label} className="border-b border-line py-3.5" data-id="element-265" data-mp="35cd3pzguwt33">
                    <dt className="text-[12px] font-medium text-ink-muted" data-id="element-266" data-mp="3a5psc9ljczvu">{row.label}</dt>
                    <dd className="mt-1 text-[16px] leading-relaxed text-ink" data-id="element-267" data-mp="3e5hspz0rzzq4">{row.value}</dd>
                  </div>)}
              </dl>
            </div>)}
        </div>
      </div>
    </section>;
}